import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';

export const Container = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 40,
});
